const dictionariesNamespace = '/dictionaries';

const dictionaryListViewRelative = '/';

const dictionaryListViewRoute = `${dictionariesNamespace}`;

export const dictionariesNamespaces = {
    dictionariesNamespace,
};

export const dictionariesRelativeRoutes = {
    dictionaryListViewRelative,
};

export const dictionariesAbsoluteRoutes = {
    dictionaryListViewRoute,
};
